
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"-17069 11542.501 14 13.326"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"cls-1",attrs:{"id":"Path_536","d":"M8.5 4.186A3.586 3.586 0 0 0 5.068 1.5a3.491 3.491 0 0 0-3.076 1.873c-1.449 2.616.566 6.08 2.333 8.027A20.031 20.031 0 0 0 8.5 14.826a21.514 21.514 0 0 0 4.167-3.426C14.435 9.453 16.449 5.989 15 3.373A3.491 3.491 0 0 0 11.925 1.5 3.618 3.618 0 0 0 8.5 4.186z","data-name":"Path 536","transform":"translate(-17070.496 11541.001)"}})])
          )
        }
      }
    